import { getApps, initializeApp } from 'firebase/app'
import {
  getAnalytics,
  isSupported,
  logEvent,
  setAnalyticsCollectionEnabled,
} from 'firebase/analytics'
import {
  firebaseAnalyticsConfig,
  firebaseAnalyticsEnabled,
} from '../config/runtime'

let analyticsPromise

function hasValue(value) {
  return Boolean(value && value.trim())
}

function hasFirebaseAnalyticsConfig(config) {
  return Object.values(config).every(hasValue)
}

function getRoutePattern(route) {
  const matchedRoute = route.matched && route.matched[route.matched.length - 1]

  return matchedRoute ? matchedRoute.path : route.path
}

function buildScreenViewParameters(route) {
  if (!route || typeof route.name !== 'string') {
    return undefined
  }

  return {
    firebase_screen: route.name,
    firebase_screen_class: getRoutePattern(route),
  }
}

async function resolveFirebaseAnalytics() {
  if (!firebaseAnalyticsEnabled || !hasFirebaseAnalyticsConfig(firebaseAnalyticsConfig)) {
    return undefined
  }

  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((supported) => {
        if (!supported) {
          return undefined
        }

        const firebaseApp = getApps()[0] || initializeApp(firebaseAnalyticsConfig)
        const analytics = getAnalytics(firebaseApp)

        setAnalyticsCollectionEnabled(analytics, true)

        return analytics
      })
      .catch(() => undefined)
  }

  return analyticsPromise
}

export async function initializeFirebaseAnalytics() {
  await resolveFirebaseAnalytics()

  return undefined
}

export async function trackFirebaseScreenView(route) {
  const screenViewParameters = buildScreenViewParameters(route)

  if (!screenViewParameters) {
    return undefined
  }

  const analytics = await resolveFirebaseAnalytics()

  if (!analytics) {
    return undefined
  }

  try {
    logEvent(analytics, 'screen_view', screenViewParameters)
  } catch {
    return undefined
  }

  return undefined
}
